<template>
  <div>
    <FlashMessages :context="context" />
    <NoticeMessage />
    <OverlayLoader />
    <SlideInSurvey />
  </div>
</template>

<script>
import FlashMessages from '@/components/_shared/FlashMessage/FlashMessages.vue'
import NoticeMessage from '@/components/_shared/NoticeMessage/NoticeMessage.vue'
import OverlayLoader from '@/components/_shared/Overlay/OverlayLoader.vue'
import SlideInSurvey from '@/components/_shared/SlideInSurvey/SlideInSurvey.vue'

export default {
  name: 'Messages',

  components: {
    FlashMessages,
    NoticeMessage,
    OverlayLoader,
    SlideInSurvey,
  },

  props: {
    context: {
      type: String,
    },
  },
}
</script>
